import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { UserLogsService } from '../user-logs/user-logs.service';

@Injectable({
  providedIn: 'root'
})
export class BackgroundService implements OnDestroy {
  private taskSubscription: Subscription | null = null;

  constructor(public authservice:AuthService,private router: Router,private userLogService:UserLogsService) { }

  startTask() {
    if (!this.taskSubscription) {      
      // debugger;
      if (this.authservice.session) {
        this.taskSubscription = interval(3 * 60 * 1000).subscribe(() => {
          // debugger;
        console.groupCollapsed("%c🔐 Ready To Hit API", "color: #4CAF50; font-weight: bold;");
        console.log("%c──────────────────────────────────────────────────────────────", "color: #9E9E9E;");
        console.log("%cDEBUG:INFO → Hitting backend service...", "color: #2196F3;");
        console.log("%c──────────────────────────────────────────────────────────────", "color: #9E9E9E;");
          this.authservice.refreshToken().subscribe({
            next: (token) => console.log("%c✅ Token refreshed:", "color: #00C853; font-weight:bold;", token),
            error: (err) => {
              console.error("%c❌ Error refreshing token:", "color: #FF1744; font-weight:bold;", err);
              this.router.navigate(['']);
            },
            complete: () => console.log("%c⏹ Token refresh complete", "color: #FFA000;")
          });
          console.groupEnd();
          this.userLogService.saveUserLogs()
        })
      }
    }
  }

  stopTask() {
    // this.taskSubscription?.unsubscribe();
    // this.taskSubscription = null;
  }

  ngOnDestroy(): void {
    // console.warn('BackgroundService destroyed! Subscription stopped.');
    // this.stopTask();
  }
}
